import React from 'react';
import TextView from "./TextView";

const FullWidthDummyView = (props) => {

  return (
    <TextView style={{height: 1, opacity: 0}}>{"Dummy text to grow the width of the view to fill the complete width available. Dummy text to grow the width of the view to fill the complete width available."}</TextView>
  );
};

export default FullWidthDummyView;
